import { apiClient } from './client'

export interface AssetDTO {
  id: number
  target_id: number | null
  host: string
  title: string | null
  ip: string | null
  port: string
  techs: string[]
  labels: string[]
  findings_count: number
  max_sev: string
  notes: string | null
}

export interface AssetCreate {
  target_id?: number
  host: string
  title?: string
  ip?: string
  port?: string
  techs?: string[]
  labels?: string[]
  max_sev?: string
}

export const assetsApi = {
  list: (params?: { target_id?: number; max_sev?: string; label?: string }) =>
    apiClient.get<AssetDTO[]>('/assets', { params }).then((r) => r.data),
  get: (id: number) => apiClient.get<AssetDTO>(`/assets/${id}`).then((r) => r.data),
  create: (body: AssetCreate) => apiClient.post<AssetDTO>('/assets', body).then((r) => r.data),
  update: (id: number, body: Partial<AssetCreate>) =>
    apiClient.patch<AssetDTO>(`/assets/${id}`, body).then((r) => r.data),
  remove: (id: number) => apiClient.delete(`/assets/${id}`).then(() => undefined),
}
